import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps,Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { sectionNames } from "../intl";
import { htmlManagerAddPath, htmlManagerPath,htmlManagerSection } from "./urls";
import { HtmlManagerDetailsView,HtmlManagerListView  } from "./views";

interface MatchParams {
  id?: string;
}

const HtmlManagerList = () => {
  return <HtmlManagerListView />;
};

const HtmlManagerDetails = ({ match }: RouteComponentProps<MatchParams>) => {
  return <HtmlManagerDetailsView id={decodeURIComponent(match.params.id!)} />;
};

const HtmlManagerAdd = () => {
  return <HtmlManagerDetailsView id="add" />;
};

const HtmlManagerSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.htmlManager)} />
      <Switch>
        <Route exact path={htmlManagerSection} component={HtmlManagerList} />
        <Route exact path={htmlManagerAddPath} component={HtmlManagerAdd} />
        <Route path={htmlManagerPath(":id")} component={HtmlManagerDetails} />
      </Switch>
    </>
  );
};

export default HtmlManagerSection;